import { render, staticRenderFns } from "./waste.vue?vue&type=template&id=72f5ff5d&scoped=true"
import script from "./waste.vue?vue&type=script&lang=js"
export * from "./waste.vue?vue&type=script&lang=js"
import style0 from "./waste.vue?vue&type=style&index=0&id=72f5ff5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5ff5d",
  null
  
)

export default component.exports